$(document).ready(function() {
  /**
   * Modal
   
  var $betaModal = $('#beta_modal');
  var betaSeen = localStorage.getItem('casterland-beta');
  if (betaSeen === null) {
    var $body = $('body');
    localStorage.setItem('casterland-beta', true);
    $body.addClass('has-open-modal');
    $betaModal.addClass('is-visible');

    $('.js-modal-close').on('click', function(e) {
      e.preventDefault();
      $betaModal.removeClass('is-visible');
      $body.removeClass('has-open-modal');
    });

    $betaModal.on('click', function(e) {
      e.preventDefault();
    });
  }*/

  /* TEST MENU */
  			$(document).ready(function() {
				//responsive menu toggle
				$("#menutoggle").click(function() {
					$('.xs-menu').toggleClass('displaynone');

					});
				//add active class on menu
				/*$('ul li').click(function(e) {
					e.preventDefault();
					$('li').removeClass('active');
					$(this).addClass('active');
				});*/
			//drop down menu 	
					$(".drop-down").hover(function() {
						$(this).addClass('display-on');
					});
					$(".drop-down").mouseleave(function() {
						$(this).removeClass('display-on');
					});
			
			});
  
  /* FIN TEST MENU*/
  
  var $shop = $('.js-shop');
  var $flyout = $('.siteHeader__flyout');
  $shop.on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('is-open');
    $flyout.toggleClass('is-open');
  });

  // hide flyout menu if the user clicks outside
  // of the menu area
  $('body').on('click', function() {
    if ($shop.hasClass('is-open')) {
      $shop.removeClass('is-open');
      $flyout.removeClass('is-open');
    }
  });

  /**
   * SidebarFilters
   * This takes care of dealing with all of our filters in
   * the left-column of the product/category pages.
   */
  var $collection = $('.js-collection');
  var $filterGroups = $('.js-filterGroup');

  /**
   * Toggles the filter drawers open/close
   */
    function drawerToggles() {
    $filterGroups.each(function() {
      var $this = $(this);

      $this.on('click', '.drawer-main', function(e) {
        e.stopPropagation();
        $this.toggleClass('is-open');
      });

      $this.on('click', '.drawer-detail', function(e) {
        e.stopPropagation();
      });
    });
  }  
  
  /**
  function drawerToggles() {
    $filterGroups.each(function() {
      var $this = $(this);

      $this.on('click', '.drawer-main', function(e) {
        e.stopPropagation();
        $this.toggleClass('is-open');
      });

      $this.on('click', '.drawer-detail', function(e) {
        e.stopPropagation();
      });
    });
  }
**/
  /**
   * Update Location
   */
  function updateLocation(url) {
    location.href = url;
  }


  /**
   * Filter Groups
   * This does a couple things:
   *   1. Sets up each filter group to look for clicks on either
   *      a filter option or a select menu, and then changes the
   *      page URL by merging the  data attributes of that gruop
   *      wuth the filter/select to create the tag that is being
   *      searched for
   *   2. Secondly, it looks into the page's URL to see if a tag
   *      has been searched for, if it has, then it prases the tag
   *      and opens the corresponding filter group and sets the
   *      selected filter/select option to be visibally selected
   */
  function filterGroups() {
    var collectionUrl = $collection.data('collectionUrl');
    var replaceUrl = 'https://casterland.com' + collectionUrl + '/';
    var tag = location.href.replace(replaceUrl, '');

    // We use this to show visible filter group & individual filter
    // based on the tag in the url param, kinda ugly but not much
    // else we can do.
    if (tag !== '') {
      var filterGroupSelector = tag.split('__')[0];
      var filterSelector = tag.split('__')[1];
      var $filterGroup = $('[data-filter-group="' + filterGroupSelector + '"]');
      $filterGroup.addClass('is-open');

      if ($filterGroup.data('filterType') === 'select') {
        $filterGroup.find('.js-select').val(filterSelector);
      } else {
        $('[data-filter-value="' + filterSelector + '"]').addClass('is-selected');
      }
    }

    $filterGroups.each(function() {
      var $this = $(this);
      var filterGroup = $this.data('filterGroup');

      // This takes care of all of the filters that are composed
      // of normal list items in the fitler sidebar
      if ($this.find('.js-filter').length > 0) {
        $this.on('click', '.js-filter', function(e) {
          e.stopPropagation();
          var $filter = $(this);
          var tag = '/' + filterGroup + '__' + $filter.data('filterValue');

          if (collectionUrl !== '') {
            updateLocation(location.origin + collectionUrl + tag);
          } else {
          }
        });
      }

      // This takes care of all of the filters that are composed
      // of select menus in the fitler sidebar
      if ($this.find('.js-select').length > 0) {
        $this.on('change', '.js-select', function() {
          var $select = $(this);
          var tag = '/' + $this.data('filterGroup') + '__' + $select.val();

          if (collectionUrl !== '') {
            updateLocation(location.origin + collectionUrl + tag);
          } else {

          }
        });
      }
    });
  }

  drawerToggles();
  filterGroups();

  /** Limit Ajax calls */
  /*	window.setInterval(function() { AJAXOK = 1 },5000);
	AJAXOK = 0;*/
  
  /**
   * Re-request Product Form
   */
  var $notify = $('.js-notify');
  var $requestForm = $('.js-requestForm');
  $notify.on('click', function (e) {
    e.preventDefault();
    var username = $('#id_name').val();
    var email = $('#id_email').val();
    var city = $('#id_city').val();
    var message = $('#id_message').val();

    if (username !== '' && email !== '' && message != '') {
      var data = {
        'contact[contact-form-name]': username,
        'contact[email]': email,
        'contact[city]': city,
        'contact[body]': message,
        'contact[product]': username + ' would like you to notify them when ' + $notify.data('title') + ' is back in stock',
        'contact[url]': $notify.data('url'),
        form_type: 'contact',
        utf8: '✓'
      }

      $.ajax({
        type: 'POST',
        async: true,
        data: data,
        dataType: 'html',
        url: '/contact',
        success: function () {
          $requestForm.html('<div class="alert alert--success">Your request has been successfully submitted, you will be notified when this product is back in stock.</div>')
        },
        error: function () {
          $requestForm.find('.form-messages').html('<div class="alert alert--error">There seems to have been a problem with the form submission. Please make sure all the fields are filled out and try again, or send us an email to webstore@casterland.com to let us know that you are interested in this item being remade.</div>')
        }
      });
    } 
    else {
    $requestForm.find('.form-messages').html('<div class="alert alert--error">There seems to have been a problem with the form submission. Please make sure all the fields are filled out and try again, or send us an email to webstore@casterland.com to let us know that you are interested in this item being remade.</div>')
    }
    });
  
   /**
   * Price-request Product Form
   */
  var $notify = $('.js-notify');
  var $priceForm = $('.js-priceForm');
  $notify.on('click', function (e) {
    e.preventDefault();
    var username = $('#id_name').val();
    var email = $('#id_email').val();
    var city = $('#id_city').val();
    var message = $('#id_message').val();

    if (username !== '' && email !== '' && message != '') {
      var data = {
        'contact[contact-form-name]': username,
        'contact[email]': email,
        'contact[city]': city,
        'contact[body]': message,
        'contact[product]': username + ' would like a quotation for the product ' + $notify.data('title'),
        'contact[url]': $notify.data('url'),
        form_type: 'contact',
        utf8: '✓'
      }

      $.ajax({
        type: 'POST',
        async: true,
        data: data,
        dataType: 'html',
        url: '/contact',
        success: function () {
          $priceForm.html('<div class="alert alert--success">Your quotation request has been successfully submitted, thank you.</div>')
        },
        error: function () {
          $priceForm.find('.form-messages').html('<div class="alert alert--error">There seems to have been a problem with the form submission. Please make sure all the fields are filled out and try again, or send us an email to webstore@casterland.com to let us know that you are interested in this item.</div>')
        }
      });
    } 
    else {
    $priceForm.find('.form-messages').html('<div class="alert alert--error">There seems to have been a problem with the form submission. Please make sure all the fields are filled out and try again, or send us an email to webstore@casterland.com to let us know that you are interested in this item.</div>')
    }
    });


  // Extend jQuery to easily parse URL parameters (or grab a single parameter)
  // @ref: http://stackoverflow.com/questions/7731778/jquery-get-query-string-parameters
  $.extend({
    getUrlVars: function() {
      var vars = [];
      var hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    getUrlVar: function(name) {
      return $.getUrlVars()[name];
    }
  });


  /**
   * Flips the Price/Alphabetical switch back and forth
   * for re-ordering the collection pages
   */
  function sortBy() {
    var currentURL = window.location.href.split('?')[0];
    var $sortInputs = $('input:radio[name="sort_by"]');

    var sortCurValue = $.getUrlVar('sort_by');

    if (sortCurValue === 'price-ascending') {
      $('#sortby_price').prop('checked', true);
    } else if (sortCurValue === 'title-ascending') {
      $('#sortby_title').prop('checked', true);
    }

    $sortInputs.on('click', function() {
      // e.stopPropagation();
      var sortValue = $('input:radio[name="sort_by"]:checked').val();
      window.location.href = currentURL + '?sort_by=' + sortValue;
    });
  }

  sortBy();



  /**
   * Tabs in the left-sidebar column of collection pages
   */
  function tabs() {
    var $triggers = $('.js-tabTrigger');
    var $tabs = $('.js-tabItem');

    // Only need to do this if we have more than 1 tab
    if ($tabs.length > 1) {
      // Hide all tabs that aren't set as the visible default
      $tabs.each(function() {
        var $this = $(this);
        if (!$this.hasClass('is-visible')) {
          $this.hide();
        }
      });

      // Loop through tab triggers to attach click handlers and
      // trigger states for buttons/tab content items
      $triggers.each(function() {
        var $this = $(this);

        $this.on('click', function() {
          $triggers.each(function() {
            $(this).removeClass('is-visible');
          });
          $this.addClass('is-visible');

          $tabs.each(function() {
            var $tab = $(this);
            $tab.hide();

            if ($this.data('target') === $tab.attr('id')) {
              $tab.show();
            }
          });
        });
      });
    }
  }

  tabs();

  /**
   * EQUALIZER
   * Takes all of the .collection-items on a page and forces
   * their height to match each other
   */
  function equalizer() {
    var $items = $('.collection-item');
    var max = 0;

    $items.each(function(e) {
      var $item = $(this);
      var height = $item.height();
      if (height > max) {
        max = height;
      }
    });

    $items.each(function(e) {
      $(this).height(max);
    })
  }

  equalizer();

});


/**
 * ============================================================================
 *   WARNING: EVERYTHING BELOW HERE IS RIPPED FROM THE SHOPIFY TIMBER THEME.
 *            >>>> EDIT AT YOUR OWN RISK. <<<<
 * ============================================================================
 */

function MultipleSelect($el, options) {
    var that = this,
        name = $el.attr('name') || options.name || '',
        elWidth = $el.width();

    this.$el = $el.hide();
    this.options = options;

    this.$parent = $('<div class="ms-parent"></div>');
    this.$choice = $('<button type="button" class="ms-choice"><span class="placeholder">' +
        options.placeholder + '</span><div></div></button>');
    this.$drop = $('<div class="ms-drop ' + options.position + '"></div>');
    this.$el.after(this.$parent);
    this.$parent.append(this.$choice);
    this.$parent.append(this.$drop);

    if (this.$el.prop('disabled')) {
        this.$choice.addClass('disabled');
    }
    this.$choice.css('width', elWidth + 'px');
    this.$drop.css({
        width: (options.width || elWidth) + 'px'
    });

    if (!this.options.keepOpen) {
        $('body').click(function(e) {
            if ($(e.target)[0] === that.$choice[0] ||
                $(e.target).parents('.ms-choice')[0] === that.$choice[0]) {
                return;
            }
            if (($(e.target)[0] === that.$drop[0] ||
                $(e.target).parents('.ms-drop')[0] !== that.$drop[0]) &&
                that.options.isOpen) {
                that.close();
            }
        });
    }

    this.selectAllName = 'name="selectAll' + name + '"';
    this.selectGroupName = 'name="selectGroup' + name + '"';
    this.selectItemName = 'name="selectItem' + name + '"';
}

MultipleSelect.prototype = {
    constructor : MultipleSelect,

    init: function() {
        var that = this,
            html = [];
        if (this.options.filter) {
            html.push(
                '<div class="ms-search">',
                    '<input type="text" autocomplete="off" autocorrect="off" autocapitilize="off" spellcheck="false">',
                '</div>'
            );
        }
        html.push('<ul>');
        if (this.options.selectAll && !this.options.single) {
            html.push(
                '<li>',
                    '<label>',
                        '<input type="checkbox" ' + this.selectAllName + ' /> ',
                        '[' + this.options.selectAllText + ']',
                    '</label>',
                '</li>'
            );
        }
        $.each(this.$el.children(), function(i, elm) {
            html.push(that.optionToHtml(i, elm));
        });
        html.push('<li class="ms-no-results">No matches found</li>');
        html.push('</ul>');
        this.$drop.html(html.join(''));
        this.$drop.find('ul').css('max-height', this.options.maxHeight + 'px');
        this.$drop.find('.multiple').css('width', this.options.multipleWidth + 'px');

        this.$searchInput = this.$drop.find('.ms-search input');
        this.$selectAll = this.$drop.find('input[' + this.selectAllName + ']');
        this.$selectGroups = this.$drop.find('input[' + this.selectGroupName + ']');
        this.$selectItems = this.$drop.find('input[' + this.selectItemName + ']:enabled');
        this.$disableItems = this.$drop.find('input[' + this.selectItemName + ']:disabled');
        this.$noResults = this.$drop.find('.ms-no-results');
        this.events();
        this.update();

        if (this.options.isOpen) {
            this.open();
        }
    },

    optionToHtml: function(i, elm, group, groupDisabled) {
        var that = this,
            $elm = $(elm),
            html = [],
            multiple = this.options.multiple,
            disabled,
            type = this.options.single ? 'radio' : 'checkbox';

        if ($elm.is('option')) {
            var value = $elm.val(),
                text = $elm.text(),
                selected = $elm.prop('selected'),
                style = this.options.styler(value) ? ' style="' + this.options.styler(value) + '"' : '';

            disabled = groupDisabled || $elm.prop('disabled');
            html.push(
                '<li' + (multiple ? ' class="multiple"' : '') + style + '>',
                    '<label' + (disabled ? ' class="disabled"' : '') + '>',
                        '<input type="' + type + '" ' + this.selectItemName + ' value="' + value + '"' +
                            (selected ? ' checked="checked"' : '') +
                            (disabled ? ' disabled="disabled"' : '') +
                            (group ? ' data-group="' + group + '"' : '') +
                            '/> ',
                        text,
                    '</label>',
                '</li>'
            );
        } else if (!group && $elm.is('optgroup')) {
            var _group = 'group_' + i,
                label = $elm.attr('label');

            disabled = $elm.prop('disabled');
            html.push(
                '<li class="group">',
                    '<label class="optgroup' + (disabled ? ' disabled' : '') + '" data-group="' + _group + '">',
                        '<input type="checkbox" ' + this.selectGroupName +
                            (disabled ? ' disabled="disabled"' : '') + ' /> ',
                        label,
                    '</label>',
                '</li>');
            $.each($elm.children(), function(i, elm) {
                html.push(that.optionToHtml(i, elm, _group, disabled));
            });
        }
        return html.join('');
    },

    events: function() {
        var that = this;
        this.$choice.off('click').on('click', function(e) {
            e.preventDefault();
            that[that.options.isOpen ? 'close' : 'open']();
        })
            .off('focus').on('focus', this.options.onFocus)
            .off('blur').on('blur', this.options.onBlur);

        this.$parent.off('keydown').on('keydown', function(e) {
            switch (e.which) {
                case 27: // esc key
                    that.close();
                    that.$choice.focus();
                    break;
            }
        });
        this.$searchInput.off('keyup').on('keyup', function() {
            that.filter();
        });
        this.$selectAll.off('click').on('click', function() {
            var checked = $(this).prop('checked'),
                $items = that.$selectItems.filter(':visible');
            if ($items.length === that.$selectItems.length) {
                that[checked ? 'checkAll' : 'uncheckAll']();
            } else { // when the filter option is true
                that.$selectGroups.prop('checked', checked);
                $items.prop('checked', checked);
                that.options[checked ? 'onCheckAll' : 'onUncheckAll']();
                that.update();
            }
        });
        this.$selectGroups.off('click').on('click', function() {
            var group = $(this).parent().attr('data-group'),
                $items = that.$selectItems.filter(':visible'),
                $children = $items.filter('[data-group="' + group + '"]'),
                checked = $children.length !== $children.filter(':checked').length;
            $children.prop('checked', checked);
            that.updateSelectAll();
            that.update();
            that.options.onOptgroupClick({
                label: $(this).parent().text(),
                checked: checked,
                children: $children.get()
            });
        });
        this.$selectItems.off('click').on('click', function() {
            that.updateSelectAll();
            that.update();
            that.updateOptGroupSelect();
            that.options.onClick({
                label: $(this).parent().text(),
                value: $(this).val(),
                checked: $(this).prop('checked')
            });
        });
    },

    open: function() {
        if (this.$choice.hasClass('disabled')) {
            return;
        }
        this.options.isOpen = true;
        this.$choice.find('>div').addClass('open');
        this.$drop.show();
        if (this.options.container) {
            var offset = this.$drop.offset();
            this.$drop.appendTo($(this.options.container));
            this.$drop.offset({ top: offset.top, left: offset.left });
        }
        if (this.options.filter) {
            this.$searchInput.val('');
            this.filter();
        }
        this.options.onOpen();
    },

    close: function() {
        this.options.isOpen = false;
        this.$choice.find('>div').removeClass('open');
        this.$drop.hide();
        if (this.options.container) {
            this.$parent.append(this.$drop);
            this.$drop.css({
                'top': 'auto',
                'left': 'auto'
            })
        }
        this.options.onClose();
    },

    update: function() {
        var selects = this.getSelects('text'),
            $span = this.$choice.find('>span');
        if (selects.length === this.$selectItems.length + this.$disableItems.length && this.options.allSelected) {
            $span.removeClass('placeholder').html(this.options.allSelected);
        } else if (selects.length > this.options.minumimCountSelected && this.options.countSelected) {
            $span.removeClass('placeholder').html(this.options.countSelected
                .replace('#', selects.length)
                .replace('%', this.$selectItems.length + this.$disableItems.length));
        } else if (selects.length) {
            $span.removeClass('placeholder').html(selects.join(', '));
        } else {
            $span.addClass('placeholder').html(this.options.placeholder);
        }
        // set selects to select
        this.$el.val(this.getSelects());
    },

    updateSelectAll: function() {
        var $items = this.$selectItems.filter(':visible');
        this.$selectAll.prop('checked', $items.length &&
            $items.length === $items.filter(':checked').length);
        if (this.$selectAll.prop('checked')) {
            this.options.onCheckAll();
        }
    },

    updateOptGroupSelect: function() {
        var $items = this.$selectItems.filter(':visible');
        $.each(this.$selectGroups, function(i, val) {
            var group = $(val).parent().attr('data-group'),
                $children = $items.filter('[data-group="' + group + '"]');
            $(val).prop('checked', $children.length &&
                $children.length === $children.filter(':checked').length);
        });
    },

    //value or text, default: 'value'
    getSelects: function(type) {
        var that = this,
            texts = [],
            values = [];
        this.$drop.find('input[' + this.selectItemName + ']:checked').each(function() {
            texts.push($(this).parent().text());
            values.push($(this).val());
        });

        if (type === 'text' && this.$selectGroups.length) {
            texts = [];
            this.$selectGroups.each(function() {
                var html = [],
                    text = $.trim($(this).parent().text()),
                    group = $(this).parent().data('group'),
                    $children = that.$drop.find('[' + that.selectItemName + '][data-group="' + group + '"]'),
                    $selected = $children.filter(':checked');

                if ($selected.length === 0) {
                    return;
                }

                html.push('[');
                html.push(text);
                if ($children.length > $selected.length) {
                    var list = [];
                    $selected.each(function() {
                        list.push($(this).parent().text());
                    });
                    html.push(': ' + list.join(', '));
                }
                html.push(']');
                texts.push(html.join(''));
            });
        }
        return type === 'text' ? texts : values;
    },

    setSelects: function(values) {
        var that = this;
        this.$selectItems.prop('checked', false);
        $.each(values, function(i, value) {
            that.$selectItems.filter('[value="' + value + '"]').prop('checked', true);
        });
        this.$selectAll.prop('checked', this.$selectItems.length ===
            this.$selectItems.filter(':checked').length);
        this.update();
    },

    enable: function() {
        this.$choice.removeClass('disabled');
    },

    disable: function() {
        this.$choice.addClass('disabled');
    },

    checkAll: function() {
        this.$selectItems.prop('checked', true);
        this.$selectGroups.prop('checked', true);
        this.$selectAll.prop('checked', true);
        this.update();
        this.options.onCheckAll();
    },

    uncheckAll: function() {
        this.$selectItems.prop('checked', false);
        this.$selectGroups.prop('checked', false);
        this.$selectAll.prop('checked', false);
        this.update();
        this.options.onUncheckAll();
    },

    focus: function() {
        this.$choice.focus();
        this.options.onFocus();
    },

    blur: function() {
        this.$choice.blur();
        this.options.onBlur();
    },

    refresh: function() {
        this.init();
    },

    filter: function() {
        var that = this,
            text = $.trim(this.$searchInput.val()).toLowerCase();
        if (text.length === 0) {
            this.$selectItems.parent().show();
            this.$disableItems.parent().show();
            this.$selectGroups.parent().show();
        } else {
            this.$selectItems.each(function() {
                var $parent = $(this).parent();
                $parent[$parent.text().toLowerCase().indexOf(text) < 0 ? 'hide' : 'show']();
            });
            this.$disableItems.parent().hide();
            this.$selectGroups.each(function() {
                var $parent = $(this).parent();
                var group = $parent.attr('data-group'),
                    $items = that.$selectItems.filter(':visible');
                $parent[$items.filter('[data-group="' + group + '"]').length === 0 ? 'hide' : 'show']();
            });

            //Check if no matches found
            if (this.$selectItems.filter(':visible').length) {
                this.$selectAll.parent().show();
                this.$noResults.hide();
            } else {
                this.$selectAll.parent().hide();
                this.$noResults.show();
            }
        }
        this.updateOptGroupSelect();
        this.updateSelectAll();
    }
};

$.fn.multipleSelect = function() {
    var option = arguments[0],
        args = arguments,

        value,
        allowedMethods = [
            'getSelects', 'setSelects',
            'enable', 'disable',
            'checkAll', 'uncheckAll',
            'focus', 'blur',
            'refresh'
        ];

    this.each(function() {
        var $this = $(this),
            data = $this.data('multipleSelect'),
            options = $.extend({}, $.fn.multipleSelect.defaults,
                $this.data(), typeof option === 'object' && option);

        if (!data) {
            data = new MultipleSelect($this, options);
            $this.data('multipleSelect', data);
        }

        if (typeof option === 'string') {
            if ($.inArray(option, allowedMethods) < 0) {
                throw "Unknown method: " + option;
            }
            value = data[option](args[1]);
        } else {
            data.init();
        }
    });

    return value ? value : this;
};

$.fn.multipleSelect.defaults = {
    name: '',
    isOpen: false,
    placeholder: '',
    selectAll: true,
    selectAllText: 'Select all',
    allSelected: 'All selected',
    minumimCountSelected: 3,
    countSelected: '# of % selected',
    multiple: false,
    multipleWidth: 80,
    single: false,
    filter: false,
    width: undefined,
    maxHeight: 250,
    container: null,
    position: 'bottom',
    keepOpen: false,

    styler: function() {return false;},

    onOpen: function() {return false;},
    onClose: function() {return false;},
    onCheckAll: function() {return false;},
    onUncheckAll: function() {return false;},
    onFocus: function() {return false;},
    onBlur: function() {return false;},
    onOptgroupClick: function() {return false;},
    onClick: function() {return false;}
};


/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    
  });
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
